import { Injectable } from '@angular/core';

const logContext = "WalkMeSupportService";

@Injectable({
  providedIn: 'root'
})
export class WalkMeSupportService {

  constructor() { }

  public initWalkMeLanguage( lang: string )
  {
    (<any>window)._langCode = lang;
  }

  public pushLanguageChangeToWalkMe( newLang: string )
  {
    // wrapping this in a try catch because if the WalkMe control is not
    // shown this will throw an error. We do not want it to break other
    // behaviour. We can't tell at this point if Walkme is available or not
    try
    {
      (<any>window)._langCode = newLang;
      if ( (<any>window).pushLanguageToWalkMe )  // not available on public or locally
        (<any>window).pushLanguageToWalkMe();
    }
    catch (e)
    {
      console.error(`${logContext}.pushLanguageChangeToWalkMe Error pushing language to WalkMe: ${e}`);
    }
  }

  setUserRole( role: string, assumedRole: boolean )
  {
    if ( assumedRole === true )
      (<any>window)._userRole = "PARTNER_ASSUMED_ACCOUNT_ADMIN";
    else
      (<any>window)._userRole = role;
  }

}
